import { setupOidcConfig } from '@preqin/preqin-core/es/OIDC/setup/preqin.OIDC.setup';

let url = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;

export const configurationOidc = setupOidcConfig({
  client_id: 'preqin.com.client.term.intelligence',
  redirect_uri: `${url}/callback`,
  silent_redirect_uri: `${url}/silentrenewcallback`,
  scope: 'openid preqin.com.default offline_access',
  authority: window._env_.IDENTITY_SERVER_URL,
  monitor_session: false,
  service_worker_relative_url: '/OidcServiceWorker.js',
  service_worker_only: true,
});
